import { Checkbox, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@shigo-ui/ui';

import { dashboardT } from '../../../../lib/messages';
import { AppInfoPopover } from './AppInfoPopover';
import {
  companyName,
  hasItemId,
  itemId,
  itemLabel,
  toRecords,
  toggleExcludedItem,
  type UnknownItem,
} from './SelectedSupplyTables.helpers';
import { ManagedSelectionTable } from './ManagedSelectionTable';
import { managedSelectionTableClassNames } from './ManagedSelectionTable.styles';

export function SelectedAppsTable({
  items,
  showCompany = true,
}: {
  items: unknown[];
  showCompany?: boolean | undefined;
}) {
  return <AppsLiteTable items={toRecords(items)} selectable={false} showCompany={showCompany} />;
}

export function AppsLiteTable({
  excludedItems = [],
  items,
  showCompany = true,
  selectable,
  onExcludedItemsChange,
}: {
  excludedItems?: unknown[] | undefined;
  items: UnknownItem[];
  selectable: boolean;
  onExcludedItemsChange?: ((items: unknown[]) => void) | undefined;
  showCompany?: boolean | undefined;
}) {
  if (!items.length) {
    return <p className="text-muted-foreground text-sm">{dashboardT('targeting.noAppsData')}</p>;
  }

  return (
    <ManagedSelectionTable aria-label={dashboardT('madBuy.common.apps')}>
      <TableHeader className={managedSelectionTableClassNames.header}>
        <TableRow className={managedSelectionTableClassNames.row}>
          <TableHead className={managedSelectionTableClassNames.head}>
            {dashboardT('madBuy.common.name')}
          </TableHead>
          <TableHead className={managedSelectionTableClassNames.head}>
            {dashboardT('targeting.info')}
          </TableHead>
          {showCompany ? (
            <TableHead className={managedSelectionTableClassNames.head}>
              {dashboardT('madBuy.common.company')}
            </TableHead>
          ) : null}
          {selectable ? (
            <TableHead className={`${managedSelectionTableClassNames.head} w-28`}>
              {dashboardT('targeting.included')}
            </TableHead>
          ) : null}
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.map((app) => {
          const checked = !hasItemId(excludedItems, itemId(app));
          return (
            <TableRow key={itemId(app)} className={managedSelectionTableClassNames.row}>
              <TableCell className={`${managedSelectionTableClassNames.cell} font-medium`}>
                {itemLabel(app)}
              </TableCell>
              <TableCell className={managedSelectionTableClassNames.cell}>
                <AppInfoPopover app={app} />
              </TableCell>
              {showCompany ? (
                <TableCell className={managedSelectionTableClassNames.cell}>
                  {companyName(app)}
                </TableCell>
              ) : null}
              {selectable ? (
                <TableCell className={managedSelectionTableClassNames.cell}>
                  <Checkbox
                    checked={checked}
                    aria-label={dashboardT('targeting.includeNamed', { name: itemLabel(app) })}
                    onCheckedChange={(value) => {
                      onExcludedItemsChange?.(
                        toggleExcludedItem(excludedItems, app, value !== true),
                      );
                    }}
                  />
                </TableCell>
              ) : null}
            </TableRow>
          );
        })}
      </TableBody>
    </ManagedSelectionTable>
  );
}
